import api from './axiosConfig';
const url = '/api/permisos';

export const permisosService = {
  async getAll() {
    const response = await api.get(url+'/obtener/roles-y-permisos', {
      withCredentials: true,
    });
    return response.data.roles_permisos;
  },

  getRoles(permisos) {
    const rolesUnicos = [...new Set(permisos.map(p => p.id_rol))];
    return rolesUnicos.map(r => ({
      value: r,
      label: r
    }));
  },

  getByRol(permisos, rolId) {
    return permisos.filter(p => p.id_rol === Number(rolId));
  }

};